<template>
  <div>
    <h3>{{ text['0004'] }} 2/4</h3>
    <hr class="title">
    <h2>{{ text['0013'] }}</h2>
    <div class="survey-categories">
      <div
        v-for="(category,id) in applications"
        @click="toggleCategorySelection(id)"
        class="survey"
        :class="{ selected: isSelected(id) }"
      >
        <div>
          <object v-if="isSelected(id)" class="check" type="image/svg+xml" data="/assets/icons/check.svg" ></object>
        </div>
        <div>
          <p><object type="image/svg+xml" :data="`/assets/icons/${id}.svg`"></object></p>
          <p>{{ category.actext }}</p>
        </div>
        <div>
        </div>
      </div>
    </div>

    <li v-for="error in validationErrors">{{ error }}</li>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        text: 'getText',
        applications: 'application/getApplications',
        validationErrors: 'getErrors',
      }),
    },
    methods: {
      ...mapActions({
        toggleCategorySelection: 'application/toggleCategorySelection',
      }),
      isSelected(categoryId) {
        return this.applications[categoryId].selected;
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/screens/Category.vue